<template>
    <content class="content" menu="应用推广" :childmenus="childmenus" :menuIndex="menuIndex" @childMenuChange = "childMenuChange" 
    :location = "location">  
        <image_list  :path = "path" :count="count"></image_list>
    </content>
</template>

<script>
    import content from './content.vue'
    import chapter_list from "../exhibition/chapter_list.vue"
    import image_list from '../exhibition/image_list.vue'
    const cityData = require('../../assets/data/support_materials.json')
    export default {
        name:"ApplicationForm",
        components:{
            content,
            chapter_list,
            image_list
        },
        props:{
        },
        data() {
            return {
                childmenus:[
				{
					name:"特色课程展示",
					path:'application_promotion/00/',
					count:3
				},
				{
					name:"组织专业展演、展览情况" ,
                    path:'application_promotion/01/',
					count:4
				},
				{
					name:"组织专家讲座情况",
                    path:'application_promotion/02/',
					count:21
				},
				{
					name:"社会评价",
                    path:'application_promotion/03/',
					count:18
				}
                ],
                path:'application_promotion/00/',
                count:16,
                location:['应用推广'],
            };
        },
        methods:{
            childMenuChange(index){
                this.path = this.childmenus[index].path;
                this.count = this.childmenus[index].count;

				this.location = [];
				this.location.push('应用推广');
				this.location.push(this.childmenus[index].name);
            }
        },
        created() {
            this.path = this.childmenus[0].path;
            this.count = this.childmenus[0].count;
        }
    }
</script>

<style lang="scss" scoped>
    .chapter_list{
        height: calc(100vh - 318px);
    }
</style>


